import Container from "../../../../components/container";
import ShoppingCompany from "../../../../models/ShoppingCompany";
import { shoppingCompanyLogoUrl } from "../../../../services/ShoppingCompanyService";
import { DeleteShoppingCompany, UpdateShoppingCompany } from "./buttons";

function Logo({ logo, name }: { logo?: string | null; name?: string }) {
  const src = shoppingCompanyLogoUrl(logo);
  if (!src) {
    return <span className="text-sm text-gray-400">No logo</span>;
  }

  return (
    <img
      src={src}
      alt={name ? `${name} logo` : "Company logo"}
      className="h-10 w-10 rounded object-contain"
    />
  );
}

export default function ShoppingCompaniesTable({
  items,
}: {
  items: ShoppingCompany[];
}) {
  return (
    <Container>
      <div className="lg:hidden">
        {items?.map((item) => (
          <div key={item.id} className="mb-2 w-full rounded-md bg-white p-4">
            <div className="flex items-center gap-3">
              <Logo logo={item.logo} name={item.name} />
              <h2>{item.name}</h2>
            </div>
            <div className="mt-2 flex items-center gap-2">
              <p>Category:</p>
              <p className="text-sm text-gray-500">{item.shoppingCategoryName || "N/A"}</p>
            </div>
            <div className="mt-2 flex items-center gap-2">
              <p>Discount code:</p>
              <p className="text-sm text-gray-500">{item.discountCode || "N/A"}</p>
            </div>
            <div className="flex items-center gap-2">
              <p>Url:</p>
              {item.url ? (
                <a className="truncate text-sm text-blue-600" href={item.url} target="_blank" rel="noreferrer">
                  {item.url}
                </a>
              ) : (
                <p className="text-sm text-gray-500">N/A</p>
              )}
            </div>
            <div className="mt-4 flex items-center justify-center gap-2">
              {item.id ? (
                <>
                  <UpdateShoppingCompany id={item.id} />
                  <DeleteShoppingCompany id={item.id} />
                </>
              ) : null}
            </div>
          </div>
        ))}
      </div>

      <table className="hidden min-w-full text-left text-gray-900 lg:table">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>
            <th className="px-6 py-3">Logo</th>
            <th className="px-6 py-3">Name</th>
            <th className="px-6 py-3">Category</th>
            <th className="px-6 py-3">Discount code</th>
            <th className="px-6 py-3">Url</th>
            <th className="px-6 py-3">Edit</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {items.map((item) => (
            <tr key={item.id} className="border-b">
              <td className="px-6 py-3">
                <Logo logo={item.logo} name={item.name} />
              </td>
              <td className="whitespace-nowrap px-6 py-3">{item.name}</td>
              <td className="whitespace-nowrap px-6 py-3">{item.shoppingCategoryName || "N/A"}</td>
              <td className="px-6 py-4">{item.discountCode || "N/A"}</td>
              <td className="max-w-xs truncate px-6 py-4">
                {item.url ? (
                  <a className="text-blue-600" href={item.url} target="_blank" rel="noreferrer">
                    {item.url}
                  </a>
                ) : (
                  "N/A"
                )}
              </td>
              <td className="px-6 py-4">
                {item.id ? (
                  <div className="flex items-center justify-start gap-2">
                    <UpdateShoppingCompany id={item.id} />
                    <DeleteShoppingCompany id={item.id} />
                  </div>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Container>
  );
}
